<template>
  <div class="layout-reviews-card">
    <div class="image">
      <slot name="image"></slot>
    </div>
    <div class="header">
      <div class="s-14 w-600"><slot name="title"></slot></div>
    </div>
    <div class="s-18 w-500"><slot name="raiting"></slot></div>
    <div class="s-14 w-500 text-rewiews"><slot name="text"></slot></div>
    <div class="button"><slot name="button"></slot></div>
  </div>
</template>

<script>
export default {
  components: {
    'ui-raiting': () => import('@/components/ui/ui-raiting.vue'),
    'ui-button': () => import('@/components/ui/ui-button.vue'),
  }
}
</script>

<style lang="scss" scoped>
.layout-reviews-card {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.image {
  position: relative;
  padding-bottom: 100%;
  overflow: hidden;
  border-radius: 7px;
  * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
}
.title {
  margin-bottom: 50px;
}
.text-rewiews{
  margin: 10px 0;
}
.button {
  margin-top: auto;
}
@media screen and (max-width: 767px) {
  .title {
    margin-bottom: 20px;
  }
}
</style>
